<template>
  <div>
    <div class="surveyBoxContainer">
      <h5>
        Q{{item.order}}. {{item.question}} {{item.essential == 'Y' ? '' : '(선택)'}} 
      </h5>
      <div class="surveyBoxInput flex flexAlignS">
        <input v-model="item.answer.data" :disabled="!isOngoing" />
      </div>
    </div>
  </div>
</template>

<script>
import {STATUS} from '@/data/survey'

export default {
  name: 'Short',
  props:{
    status: null,
    item: null
  },
  data(){
    return{
      isOngoing: false,
    }
  },
  mounted(){
    this.init();
  },
  methods : {
    init(){
      switch(this.status){
        case STATUS.ONGOING:
          this.isOngoing = true
          break
        default:
          this.isOngoing = false
          break
      }
    }
  }
}
</script>